import { authorizedAPI } from '@/config/axios.config';
import { UtilsService } from '@/services/utils/utils.service';

const utils = new UtilsService();

export interface SaveFormDraftDto {
  processId: string;
  formId: string;
  applicantProcessId: string;
  responses: any;
}

class FormDraftService {
  save(payload: SaveFormDraftDto): Promise<any> {
    return utils.handleApiRequest(() =>
      authorizedAPI.post('/form-drafts', payload)
    );
  }

  getDraft(applicantProcessId: string, formId: string): Promise<any> {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/form-drafts/${applicantProcessId}/${formId}`)
    );
  }

  getByApplication(applicantProcessId: string): Promise<any> {
    return utils.handleApiRequest(() =>
      authorizedAPI.get(`/form-drafts/application/${applicantProcessId}`)
    );
  }

  discard(applicantProcessId: string, formId: string): Promise<any> {
    return utils.handleApiRequest(() =>
      authorizedAPI.delete(`/form-drafts/${applicantProcessId}/${formId}`)
    );
  }
}

export const formDraftService = new FormDraftService();
